import Breadcrumb from "../../../shared/CustomBreadcrumb"
import { Card } from "@volvo/vcdk-react/Card";
import { CardContent } from "@volvo/vcdk-react/CardContent";
import { Typography } from "@volvo/vcdk-react/Typography";
import DealerReportGrid from "../../../components/PassRateReport/PassRateSummary/PassRateReportDealer"
import RegionReportGrid from "../../../components/PassRateReport/PassRateSummary/PassRateReportRegion"
import PassRateSummaryFilter from "../../../components/PassRateReport/PassRateSummary/PassRateSummaryFilter"

const styleCardContent={"--vcdk-spacing-8":".4rem"}  as React.CSSProperties
const PassRateSummary = () => (
    <>
        <Breadcrumb crumbs={['Manage MOT', 'Pass Rates Summary']} />
        <PassRateSummaryFilter />
       <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 p-0 pe-2 ps-3 pb-1">
               <Card >
                    <CardContent style={styleCardContent}>
                        <Typography variant='subtitle2' className="text-muted" style={{marginBottom:".4rem"}}>Prepared in Region Pass Rates with % of NAT</Typography>
                        <RegionReportGrid />
                    </CardContent>
                </Card>
             </div>
            <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 p-0 pe-3">
               <Card >
                     <CardContent style={styleCardContent}>
                        <Typography variant='subtitle2' className="text-muted" style={{marginBottom:".4rem"}}>Prepared by Region Pass Rates</Typography>
                        <DealerReportGrid />
                    </CardContent>
                </Card>
             </div>
        </div>
    </>
)
export default PassRateSummary
